import { cloneDeep, merge } from "lodash-es"
import type { PvChartBlock, PvChartsMap } from "../types/pv-common.types"

/**
 * Fusionne les blocs « charts » gabarit + analyse (même ordre logique que le legacy
 * `PVScenarioCard` / lodash `merge` sur chaque clé de fréquence).
 *
 * @param analyseCharts - Charts issus du document d’analyse (données mesurées / calculées).
 * @param templateCharts - Charts issus du template métier (libellés, séries complémentaires).
 */
export function mergePvDimensionnementCharts(
    analyseCharts: PvChartsMap | undefined | null,
    templateCharts: unknown
): PvChartsMap {
    const analyse =
        analyseCharts && typeof analyseCharts === "object"
            ? (analyseCharts as Record<string, unknown>)
            : {}
    const template =
        templateCharts && typeof templateCharts === "object"
            ? (templateCharts as Record<string, unknown>)
            : {}

    const keys = new Set([...Object.keys(template), ...Object.keys(analyse)])
    const out: PvChartsMap = {}

    for (const key of keys) {
        const aBlock = analyse[key]
        const tBlock = template[key]
        if (
            typeof aBlock !== "object" ||
            aBlock === null ||
            typeof tBlock !== "object" ||
            tBlock === null
        ) {
            if (typeof aBlock === "object" && aBlock !== null) {
                out[key] = cloneDeep(aBlock) as PvChartBlock
            } else if (typeof tBlock === "object" && tBlock !== null) {
                out[key] = cloneDeep(tBlock) as PvChartBlock
            }
            continue
        }
        out[key] = merge({}, tBlock as object, aBlock as object) as PvChartBlock
    }

    return out
}
